/* tslint:disable */

/* eslint-disable */

/**
 * API Gateway Backstage Plugin
 * Backstage plugins api spec
 *
 * The version of the OpenAPI document: v1
 * Contact: sarkan.mo@tomtom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { Route } from './Route';
import { RouteFromJSON, RouteToJSON } from './Route';

/**
 *
 * @export
 * @interface Product
 */
export interface Product {
  /**
   * The internal name of the product.
   * @type {string}
   * @memberof Product
   */
  name?: string;
  /**
   * The user-facing display name for the product.
   * @type {string}
   * @memberof Product
   */
  displayName?: string;
  /**
   * How the product is exposed.
   * @type {string}
   * @memberof Product
   */
  exposition?: string;
  /**
   * The name of the parent product, if any.
   * @type {string}
   * @memberof Product
   */
  parent?: string;
  /**
   *
   * @type {Array<Route>}
   * @memberof Product
   */
  routes?: Array<Route>;
}

/**
 * Check if a given object implements the Product interface.
 */
// @ts-ignore
export function instanceOfProduct(value: object): value is Product {
  return true;
}

export function ProductFromJSON(json: any): Product {
  return ProductFromJSONTyped(json, false);
}

export function ProductFromJSONTyped(
  json: any,
  // @ts-ignore
  ignoreDiscriminator: boolean,
): Product {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    displayName:
      json['display_name'] == null ? undefined : json['display_name'],
    exposition: json['exposition'] == null ? undefined : json['exposition'],
    parent: json['parent'] == null ? undefined : json['parent'],
    routes:
      json['routes'] == null
        ? undefined
        : (json['routes'] as Array<any>).map(RouteFromJSON),
  };
}

export function ProductToJSON(json: any): Product {
  return ProductToJSONTyped(json, false);
}

export function ProductToJSONTyped(
  value?: Product | null,
  // @ts-ignore
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
    display_name: value['displayName'],
    exposition: value['exposition'],
    parent: value['parent'],
    routes:
      value['routes'] == null
        ? undefined
        : (value['routes'] as Array<any>).map(RouteToJSON),
  };
}
